import { ref } from '@vue/composition-api';
import { $api } from '@/store/ApiClient';
import { openPdfInNewTab } from '@/utils/pdfTab';

/**
 * PDFプレビュー用のComposable
 * vue3配下のコンポーネント専用
 */
export const usePdfPreview = () => {
  const pdfLoading = ref({});

  /**
   * PDFを別ウィンドウで開く
   * @param {String} documentManageId - ドキュメント管理ID
   * @param {Number} documentTrx - ドキュメントトランザクション
   * @param {String} documentName - ドキュメント名
   * @returns {Promise<void>}
   */
  const openPdfInNewWindow = async (
    documentManageId,
    documentTrx,
    documentName,
  ) => {
    pdfLoading.value[documentManageId] = true;

    try {
      await openPdfInNewTab({
        key: `${documentManageId}_${documentTrx}`,
        name: documentName,
        loader: () =>
          $api.download(
            { documentManageId, documentTrx },
            documentName,
            null,
            null,
            false,
          ),
      });
    } finally {
      pdfLoading.value[documentManageId] = false;
    }
  };

  /**
   * PDFのBlobURLを取得（プレビュー用）
   * @param {String} documentManageId - ドキュメント管理ID
   * @param {Number} documentTrx - ドキュメントトランザクション
   * @param {String} documentName - ドキュメント名
   * @returns {Promise<String>} - Blob URL
   */
  const downloadPdf = async (documentManageId, documentTrx, documentName) => {
    const path = {
      documentManageId,
      documentTrx,
    };

    return await $api.download(path, documentName, null, null, false);
  };

  return {
    pdfLoading,
    openPdfInNewWindow,
    downloadPdf,
  };
};
